import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=58304cf3&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=ts"
export * from "./MemberCard.vue?vue&type=script&lang=ts"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=58304cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58304cf3",
  null
  
)

export default component.exports